require('./lbaEnhancedLogItem.scss');
const $inject = [];
const lbaEnhancedLogItem = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '=',
      name: '=',
      cake: '=',
      indexArray: '@'
    },
    bindToController: true,
    controller: 'lbaEnhancedLogItemCtrl',
    controllerAs: 'vm',
    template: require('./lbaEnhancedLogItem.html')
  }
};

lbaEnhancedLogItem.$inject = $inject;

export default lbaEnhancedLogItem;



// WEBPACK FOOTER //
// ./src/components/lbaEnhancedLogItem/lbaEnhancedLogItemDir.js